import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./components/Home";
import ServicePage from "./components/ServicePage";
import { Toaster } from "./components/ui/toaster";
import { LanguageProvider } from "./contexts/LanguageContext";
import ScrollToTop from "./components/ScrollToTop";

// Public page imports
import Documents from "./pages/Documents";
import Articles from "./pages/Articles";
import ArticleDetail from "./pages/ArticleDetail";
import About from "./pages/About";
import FAQ from "./pages/FAQ";
import ServicesPage from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import NotFound from "./pages/NotFound";

// Admin imports
import { AdminAuthProvider } from "./admin/contexts/AdminAuthContext";
import ProtectedRoute from "./admin/components/ProtectedRoute";
import AdminLayout from "./admin/components/AdminLayout";
import AdminLogin from "./admin/pages/AdminLogin";
import Dashboard from "./admin/pages/Dashboard";
import Inquiries from "./admin/pages/Inquiries";
import Pages from "./admin/pages/Pages";
import ServicesManagement from "./admin/pages/ServicesManagement";
import BlockedIPs from "./admin/pages/BlockedIPs";
import Users from "./admin/pages/Users";
import FAQManagement from "./admin/pages/FAQManagement";
import DocumentsManagement from "./admin/pages/DocumentsManagement";
import ArticlesManagement from "./admin/pages/ArticlesManagement";
import SettingsEditor from "./admin/pages/SettingsEditor";
import NewsAgent from "./admin/pages/NewsAgent";
import NewsSourcesManagement from "./admin/pages/NewsSourcesManagement";
import CronMonitoring from "./admin/pages/CronMonitoring";

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <LanguageProvider>
              <Home />
              <Toaster />
            </LanguageProvider>
          } />
          <Route path="/service/:slug" element={
            <LanguageProvider>
              <ServicePage />
              <Toaster />
            </LanguageProvider>
          } />
          <Route path="/services" element={
            <LanguageProvider>
              <ServicesPage />
              <Toaster />
            </LanguageProvider>
          } />
          <Route path="/services/:slug" element={
            <LanguageProvider>
              <ServiceDetail />
              <Toaster />
            </LanguageProvider>
          } />
          <Route path="/documents" element={
            <LanguageProvider>
              <Documents />
              <Toaster />
            </LanguageProvider>
          } />
          <Route path="/articles" element={
            <LanguageProvider>
              <Articles />
              <Toaster />
            </LanguageProvider>
          } />
          <Route path="/articles/:slug" element={
            <LanguageProvider>
              <ArticleDetail />
              <Toaster />
            </LanguageProvider>
          } />
          <Route path="/about" element={
            <LanguageProvider>
              <About />
              <Toaster />
            </LanguageProvider>
          } />
          <Route path="/faq" element={
            <LanguageProvider>
              <FAQ />
              <Toaster />
            </LanguageProvider>
          } />

          {/* Admin Routes */}
          <Route path="/admin/login" element={
            <AdminAuthProvider>
              <AdminLogin />
            </AdminAuthProvider>
          } />
          
          <Route path="/admin" element={
            <AdminAuthProvider>
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            </AdminAuthProvider>
          }>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="inquiries" element={<Inquiries />} />
            <Route path="pages" element={<Pages />} />
            <Route path="services" element={<ServicesManagement />} />
            <Route path="faqs" element={<FAQManagement />} />
            <Route path="documents" element={<DocumentsManagement />} />
            <Route path="articles" element={<ArticlesManagement />} />
            <Route path="news-agent" element={<NewsAgent />} />
            <Route path="news-sources" element={<NewsSourcesManagement />} />
            <Route path="cron-monitoring" element={<CronMonitoring />} />
            <Route path="settings" element={<SettingsEditor />} />
            <Route path="blocked-ips" element={<BlockedIPs />} />
            <Route path="users" element={<Users />} />
          </Route>

          {/* Catch-all: any unknown URL -> 404 page (prevents blank screens
              for outdated/mistyped links and old indexed URLs) */}
          <Route path="*" element={
            <LanguageProvider>
              <NotFound />
              <Toaster />
            </LanguageProvider>
          } />
        </Routes>
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;